import React, { FunctionComponent } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import RequireAuth from "./RequireAuth";
import RequireContent from "./RequireContent";

import FeatureWrapper from "components/FeatureToggle/FeatureWrapper";

const Home = React.lazy(() => import(/* webpackChunkName: "Home", webpackPrefetch: true */ "routes/Home"));
const MyAccount = React.lazy(() => import(/* webpackChunkName: "Home", webpackPrefetch: true */ "routes/MyAccount"));
const Basket = React.lazy(() => import(/* webpackChunkName: "Basket", webpackPrefetch: true */ "routes/Basket"));
const Checkout = React.lazy(() => import(/* webpackChunkName: "Checkout", webpackPrefetch: true */ "routes/Checkout"));
const SelectCreditCard = React.lazy(
  () => import(/* webpackChunkName: "SelectCreditCard", webpackPrefetch: true */ "routes/SelectCreditCard"),
);

const NotFound = React.lazy(() => import(/* webpackChunkName: "NotFound", webpackPrefetch: true */ "routes/NotFound"));
const MoreInfo = React.lazy(() => import(/* webpackChunkName: "MoreInfo", webpackPrefetch: true */ "routes/MoreInfo"));

const CookiePreferences = React.lazy(
  () => import(/* webpackChunkName: "CookiePreferences", webpackPrefetch: true */ "routes/CookiePreferences"),
);

const AccessibilityStatement = React.lazy(
  () => import(/* webpackChunkName: "AccessibilityStatement", webpackPrefetch: true */ "routes/AccessibilityStatement"),
);

const OfferDetails = React.lazy(
  () => import(/* webpackChunkName: "OfferDetails", webpackPrefetch: true */ "routes/OfferDetails"),
);

const MultiPlanOffer = React.lazy(
  () => import(/* webpackChunkName: "OfferDetails", webpackPrefetch: true */ "routes/MultiPlanOffer"),
);

const OfferCancellation = React.lazy(
  () => import(/* webpackChunkName: "OfferCancellation", webpackPrefetch: true */ "routes/OfferCancellation"),
);

const PreSetupForm = React.lazy(
  () => import(/* webpackChunkName: "PreSetupForm", webpackPrefetch: true */ "routes/PreSetupForm"),
);

const NotEligible = React.lazy(
  () => import(/* webpackChunkName: "NotEligible", webpackPrefetch: true */ "routes/NotEligible"),
);

const ContractSelector = React.lazy(
  () => import(/* webpackChunkName: "ContractSelector", webpackPrefetch: true */ "routes/ContractSelector"),
);

const ErrorPage = React.lazy(
  () => import(/* webpackChunkName: "ErrorPage", webpackPrefetch: true */ "routes/ErrorPage"),
);

const NotEllegibleUser = React.lazy(
  () => import(/* webpackChunkName: "notEllegibleUser", webpackPrefetch: true */ "routes/NotElligibleUser"),
);

const AppRoutes: FunctionComponent = () => {
  return (
    <Routes>
      <Route path={""} element={<Home />} />
      <Route
        path={"myaccount"}
        element={
          <RequireAuth>
            <MyAccount />
          </RequireAuth>
        }
      />
      {/** TODO: for now the user is redirected to the home page, but if after the mvp we need this route, it should be <ServiceSelection /> */}
      <Route
        path={"service-selection"}
        element={
          <RequireAuth noAuthElement={<Navigate to="/" />}>
            <Navigate to="/" />
          </RequireAuth>
        }
      />

      <Route
        path={"cable"}
        element={
          <RequireAuth>
            <ContractSelector />
          </RequireAuth>
        }
      />

      <Route
        path={"offer/:name"}
        element={
          <RequireContent>
            <OfferDetails />
          </RequireContent>
        }
      />
      <Route
        path={"offer/:name/pre-setup-form"}
        element={
          <RequireContent>
            <PreSetupForm />
          </RequireContent>
        }
      />
      <Route
        path={"offer/:name/not-eligible"}
        element={
          <RequireContent>
            <NotEligible />
          </RequireContent>
        }
      />
      <Route path={"not-eligible-user"} element={<NotEllegibleUser />} />
      <Route
        path={"offer/:name/cancellation"}
        element={
          <RequireContent>
            <OfferCancellation />
          </RequireContent>
        }
      />
      <Route path={"cookie-preferences"} element={<CookiePreferences />} />
      <Route path={"accessibility"} element={<AccessibilityStatement />} />
      <Route
        path={"basket"}
        element={
          <RequireAuth>
            <Basket />
          </RequireAuth>
        }
      />
      <Route
        path={"checkout"}
        element={
          <RequireAuth>
            <Checkout />
          </RequireAuth>
        }
      />
      <Route
        path={"select-credit-card"}
        element={
          <FeatureWrapper name="CreditCardPurchase" route={true}>
            <RequireAuth>
              <SelectCreditCard />
            </RequireAuth>
          </FeatureWrapper>
        }
      />
      <Route
        path={"more-info/:partnerName"}
        element={
          <RequireContent>
            <MoreInfo />
          </RequireContent>
        }
      />
      <Route
        path={"multiplanoffer/:name"}
        element={
          <RequireContent>
            <MultiPlanOffer />
          </RequireContent>
        }
      />
      <Route path={"error"} element={<ErrorPage />} />
      <Route path={"notfound"} element={<NotFound />} />
      <Route path="*" element={<Navigate to="/notfound" />} />
    </Routes>
  );
};

export default AppRoutes;
